var IbmDuplCheckController = (function () {
    function IbmDuplCheckController(topic, $injector, env, $stateParams, $scope) {
        this.topic = topic;
        this.$injector = $injector;
        this.env = env;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.comp = 'dc_sc';
        this.scCheckData = _.get(this, 'topic.checksData.result');
        this.scResult = this.scCheckData && angular.isDefined(this.scCheckData.DUPSC) ? [this.scCheckData.DUPSC.data] : undefined;
        this.tableName = 'IBM Duplicate Check';
        this.visible = false;
        this.filterDisplay = false;
    }
    IbmDuplCheckController.prototype.toggleFilter = function () {
        this.filterDisplay = !this.filterDisplay;
    };
    IbmDuplCheckController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    IbmDuplCheckController.prototype.isSectionEnabled = function () {
        return _.get(this, 'scResult') !== undefined
            ? !this.scResult.isError
            : false;
    };
    IbmDuplCheckController.$inject = ['topic', '$injector', 'env', '$stateParams', '$scope', '_'];
    return IbmDuplCheckController;
}());
var DetailTableIbmCheckComponent = (function () {
    function DetailTableIbmCheckComponent() {
        this.templateUrl = 'detail-table-ibm-duplcheck.html';
        this.controllerAs = 'vm';
        this.controller = IbmDuplCheckController;
    }
    return DetailTableIbmCheckComponent;
}());
angular
    .module('application')
    .component('detailTableIbmCheck', new DetailTableIbmCheckComponent());

//# sourceMappingURL=detail.table.ibm.duplcheck.component.js.map
